
    import { C1_COLORS } from '@/C1Components/utils/variants';

    export default {
        name: 'C1HelpText',

        props: {
            color: {
                type: String,
                default: 'cool-gray',
                validator: value => C1_COLORS.includes(value),
            },
        },

        computed: {
            classList() {
                return [
                    'text-xs m-0 py-1 leading-3',
                    this.getTextColorClass,
                ];
            },

            getTextColorClass() {
                return `text-c1-${this.color}-400`;
            },
        },
    };
